function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-9",
  transform: "translate(-77.000000, -846.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(77.000000, 846.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fillOpacity: 0.2,
  fill: "#1BBD9D",
  cx: 15,
  cy: 15,
  r: 15
}), React.createElement("g", {
  id: "24px-37",
  transform: "translate(5.000000, 5.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 20 0 20 20 0 20"
}), React.createElement("path", {
  d: "M4.16666667,10.9833333 L4.16666667,14.3166667 L10,17.5 L15.8333333,14.3166667 L15.8333333,10.9833333 L10,14.1666667 L4.16666667,10.9833333 Z M10,2.5 L0.833333333,7.5 L10,12.5 L17.5,8.40833333 L17.5,14.1666667 L19.1666667,14.1666667 L19.1666667,7.5 L10,2.5 Z",
  id: "Shape",
  fill: "#1BBD9D",
  fillRule: "nonzero"
})))));

var SvgEducationCluster = function SvgEducationCluster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEducationCluster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education-cluster.909fec94.svg";
export { ForwardRef as ReactComponent };